import styled from 'styled-components';
import { ErrorMessage } from '@libs/components';
import { CurrencyInputWithBalanceOptions } from 'src/components';

export const DepositCardContainer = styled.div`
  padding: 2rem 2rem 3.6rem 2rem;

  ${({ theme }) => theme.media.tablet`
  padding: 2rem 3.6rem 3.6rem 3.6rem;

  `};
`;
export const DisclaimerContainer = styled.div`
  margin: 1.2rem 0 3.2rem;
`;
export const CardContainer = styled.div`
  margin-top: 1.2rem;
`;
export const AmountInputContainer = styled.div`
  margin: 0.8rem 0 1.2rem;
`;

export const AmountTextsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  gap: 0.8rem;
`;

export const AmountTextWrapper = styled.div`
  display: flex;
  align-items: center;

  justify-content: space-between;

  width: 100%;
`;

export const LessThanFeeErrorMsg = styled(ErrorMessage)`
  margin-top: 1.2rem;
`;

export const CustomCurrencyInputWithBalanceOptions = styled(
  CurrencyInputWithBalanceOptions
)`
  border-radius: ${({ theme }) => theme.borderRadius.x5};
  .input-placeholder {
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`;
